import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '@/views/Home.vue';
const Projects = () => import('@/views/Projects.vue');
const NewProject = () => import('@/views/NewProject.vue');
const Editor = () => import('@/views/Editor.vue');
const Learn = () => import('@/views/Learn.vue');
const Play = () => import('@/views/Play.vue');
const Debugger = () => import('@/views/Debugger.vue');
const EditProject = () => import('@/views/EditProject.vue');
const SubmitProject = () => import('@/views/SubmitProject.vue');
const Submitted = () => import('@/views/Submitted.vue');
const SearchSubmissions = () => import('@/views/SearchSubmissions.vue');
const Offline = () => import('@/views/Offline.vue');

Vue.use(VueRouter);

const routes: RouteConfig[] = [
    { path: '/',            name: 'home',              component: Home       },
    { path: '/learn',       name: 'learn',             component: Learn      },
    { path: '/play/:id',    name: 'play',              component: Play       },
    { path: '/projects',    name: 'projects',          component: Projects   },
    { path: '/offline',     name: 'offline',           component: Offline    },
    { path: '/search',      name: 'searchSubmissions', component: SearchSubmissions },
    { path: '/edit',        name: 'edit',              component: EditProject,   meta: { requiresAuth: true } },
    { path: '/new-project', name: 'new-project',       component: NewProject,    meta: { requiresAuth: true } },
    { path: '/editor/:id',  name: 'editor',            component: Editor,        meta: { requiresAuth: true } },
    { path: '/debugger',    name: 'debugger',          component: Debugger,      meta: { requiresAuth: true } },
    { path: '/submit',      name: 'submit',            component: SubmitProject, meta: { requiresAuth: true } },
    { path: '/submitted',   name: 'submitted',         component: Submitted,     meta: { requiresAuth: true } },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
